import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';

import { HeaderSEOBlockByPinContainer } from '../HeaderSEOBlock';
import { SEOBlockLayout } from '../SEOBlockLayout';

export const SEOBlockByPin = memoWithDisplayName(
  () => <SEOBlockLayout averagePrice={null} header={<HeaderSEOBlockByPinContainer />} quickLinks={null} />,
  'SEOBlockByPin',
);
